import { ShaderInputs } from "./ShaderInputs";
import { BasePreprocessingShader } from "./BasePreprocessingShader";
import { engine } from "../KotlinLib";

export class DiffuseColoredAtShader extends BasePreprocessingShader implements ShaderInputs {
    view_proj_matrix: WebGLUniformLocation | undefined;
    sTexture: WebGLUniformLocation | undefined;
    color: WebGLUniformLocation | undefined;
    rm_Vertex: number | undefined;
    rm_TexCoord0: number | undefined;

    public attributes?: number[];
    public typedAttributes?: { [key: number]: number };
    public uniforms?: WebGLUniformLocation[];

    /** @inheritdoc */
    fillCode() {
        this.vertexShaderCode = `precision highp float;
            uniform mat4 view_proj_matrix;
            attribute vec4 rm_Vertex;
            attribute vec2 rm_TexCoord0;
            varying vec2 vTextureCoord;
            /*UNIFORMS*/

            void main() {
              gl_Position = view_proj_matrix * rm_Vertex;
              vTextureCoord = rm_TexCoord0;
              /*POST_VERTEX*/;
            }`;

        this.fragmentShaderCode = `precision mediump float;
            varying vec2 vTextureCoord;
            uniform sampler2D sTexture;
            uniform vec4 color;
            /*UNIFORMS*/

            void main() {
              vec4 diffuse = texture2D(sTexture, vTextureCoord);
              gl_FragColor = diffuse * color;
              /*POST_FRAGMENT*/;
              if (diffuse.a < 0.5) { discard; }
            }`;
    }

    /** @inheritdoc */
    fillUniformsAttributes() {
        this.rm_Vertex = this.getAttrib("rm_Vertex");
        this.rm_TexCoord0 = this.getAttrib("rm_TexCoord0");

        this.view_proj_matrix = this.getUniform("view_proj_matrix");
        this.sTexture = this.getUniform("sTexture");
        this.color = this.getUniform("color");

        this.attributes = [this.rm_Vertex, this.rm_TexCoord0];
        this.typedAttributes = {
            [engine.AttributeType.VERTEX.ordinal]: this.rm_Vertex!,
            [engine.AttributeType.UV0.ordinal]: this.rm_TexCoord0!
        };
        this.uniforms = [this.view_proj_matrix, this.sTexture, this.color];
    }
}
